import { useState } from "react";

function useMessageModal() {
  const [messageModal, setMessageModal] = useState({
    isVisible: false,
    header: "Header",
    message: "body",
    timeout: 30000,
    showBotAnimation: true,
    headerBg: "primary",
  });

  const updateMessageModal = (obj) => {
    const acceptedBgs = ["primary", "red"];

    const newObj = {
      isVisible:
        typeof obj?.isVisible === "boolean" ? obj.isVisible : messageModal.show,
      header: typeof obj.header === "string" ? obj.header : messageModal.header,
      showBotAnimation:
        typeof obj?.showBotAnimation === "boolean"
          ? obj.showBotAnimation
          : messageModal.showBotAnimation,
      message:
        typeof obj.message === "string" || Array.isArray(obj.message)
          ? obj.message
          : messageModal.message,
      headerBg: acceptedBgs.includes(obj.headerBg)
        ? obj.headerBg
        : messageModal.headerBg,
    };
    setMessageModal(newObj);
  };

  return { messageModal, updateMessageModal };
}

export default useMessageModal;
